import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, imageUrl, caption }) => {
  if (!isOpen || !imageUrl) return null;

  // Determine if it's an image or video based on the file extension or URL
  const isVideo = imageUrl && (imageUrl.includes('.mp4') || imageUrl.includes('.webm') || imageUrl.includes('video'));

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close modal">
          &times;
        </button>
        {isVideo ? (
          <video 
            src={imageUrl} 
            controls 
            className="modal-media"
            aria-label={caption || 'Gallery video'}
          />
        ) : (
          <img src={imageUrl} alt={caption || 'Gallery image'} className="modal-media" />
        )}
        {caption && (
          <div className="modal-caption">
            <p>{caption}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal; 